import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { useModalContext } from '@providers/ModalProvider';
import { SmsWhitelistService } from 'app/API';
import { notifyApiCallError } from 'app/http/notifyApiCallError';
import { useState } from 'react';

import { Content } from './CreateNewWhitelistNumber/styles/Content';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
};

export const CreateNewWhitelistNumber = ({ onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { closeModal } = useModalContext();
  const [whitelist, setWhitelist] = useState({
    number: '',
  });

  const submitMutation = useMutation({
    mutationFn: () => call(() => SmsWhitelistService.create({ requestBody: { number: whitelist.number } })),
    onSuccess: () => {
      closeModal();
      onSuccess();
    },
    onError: notifyApiCallError,
  });

  const handleSubmit = () => submitMutation.mutate();

  return (
    <ModalWrapper width="370px">
      {submitMutation.isPending ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Whitelist mobile number</ModalTitle>
      <Content>
        <div className="input-wrapper">
          <div className="label">Mobile number</div>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setWhitelist({ ...whitelist, number: e.target.value })
            }
            label="Number with international prefix"
            placeholder='e.g. "+6588943230"'
            value={whitelist.number}
          />
        </div>

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={handleSubmit} disabled={submitMutation.isPending}>
            Save
          </Button>
        </div>
      </Content>
    </ModalWrapper>
  );
};
